import { AiRequestMetadataInput } from "@/modules/chats/services/ai/ch/__generated__/chNextBestQuestionsQuery.graphql"
import { chNextBestQuestionsQuery } from "@/modules/chats/services/ai/ch/chNextBestQuestionsQuery"
import { deNextBestQuestionsQuery } from "@/modules/chats/services/ai/de/deNextBestQuestionsQuery"
import { Country } from "@/types/__generated__/union-types"

export const nextBestQuestionsQuery = (country: Country, aiRequestMetadata: AiRequestMetadataInput) => {
  if (country === "DE") {
    return deNextBestQuestionsQuery(aiRequestMetadata)
  }
  return chNextBestQuestionsQuery(aiRequestMetadata)
}
